import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=4b7c2c3c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7c2c3c')) {
      api.createRecord('4b7c2c3c', component.options)
    } else {
      api.reload('4b7c2c3c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=4b7c2c3c&", function () {
      api.rerender('4b7c2c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LvR7dwUC1mOC/JS/comp/ImgFallback.vue"
export default component.exports